import PropTypes from "prop-types";
import { useState } from "react";

import CardShell, { BackToSignIn } from "./card_shell";
import { PasswordField } from "./fields";
import { ErrorSummary } from "./status_messages";

const PasswordResetPage = ({
  paths,
  authenticityToken,
  errors,
  resetPasswordToken,
  submitLabel = "Save password",
  passwordTitle = "Set your password",
  newPasswordTooltipTitle = "Your new password",
  newPasswordTooltipBody = "Your password lets you sign in with email + password. To send 1-on-1 emails or calendar invites from contact profiles, you'll also need to connect Google or Microsoft on the sign-in page.",
}) => {
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  return (
    <CardShell>
      <form action={paths.passwordUpdate} method="post">
        <input
          type="hidden"
          name="authenticity_token"
          value={authenticityToken}
        />
        <input type="hidden" name="_method" value="put" />
        <input
          type="hidden"
          name="user[reset_password_token]"
          value={resetPasswordToken || ""}
        />

        <h1 className="auth-subtitle text-center">{passwordTitle}</h1>

        <ErrorSummary errors={errors} />

        <PasswordField
          id="user_new_password"
          name="user[password]"
          label="New password"
          placeholder="New password"
          value={password}
          onChange={setPassword}
          autoComplete="new-password"
          tooltipTitle={newPasswordTooltipTitle}
          tooltipBody={newPasswordTooltipBody}
        />

        <PasswordField
          id="user_password_confirmation"
          name="user[password_confirmation]"
          label="Confirm new password"
          placeholder="Confirm new password"
          value={passwordConfirmation}
          onChange={setPasswordConfirmation}
          autoComplete="new-password"
        />

        <button
          type="submit"
          className="btn btn-lg btn-block auth-primary-button"
        >
          {submitLabel}
        </button>
      </form>

      <BackToSignIn path={paths.signIn} />
    </CardShell>
  );
};

PasswordResetPage.propTypes = {
  paths: PropTypes.shape({
    passwordUpdate: PropTypes.string.isRequired,
    signIn: PropTypes.string.isRequired,
  }).isRequired,
  authenticityToken: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
  resetPasswordToken: PropTypes.string,
  submitLabel: PropTypes.string,
  passwordTitle: PropTypes.string,
  newPasswordTooltipTitle: PropTypes.string,
  newPasswordTooltipBody: PropTypes.string,
};

export default PasswordResetPage;
